import React from "react";

export default function ColorFrame30({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#F9E6CA"
          d="M45.952 59.955l28.49 196.823c1.557 10.753 8.997 18.567 17.678 18.567H183.88c8.682 0 16.122-7.814 17.678-18.567l28.491-196.823c2.01-13.89-6.464-26.68-17.678-26.68H63.63c-11.214 0-19.689 12.79-17.678 26.68z"
        ></path>
        <mask
          id="mask0_2256_161599"
          style={{ maskType: "alpha" }}
          width="186"
          height="243"
          x="45"
          y="33"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#F9E6CA"
            d="M45.952 59.955l28.49 196.823c1.557 10.753 8.997 18.567 17.678 18.567H183.88c8.682 0 16.122-7.814 17.678-18.567l28.491-196.823c2.01-13.89-6.464-26.68-17.678-26.68H63.63c-11.214 0-19.689 12.79-17.678 26.68z"
          ></path>
        </mask>
        <g mask="url(#mask0_2256_161599)">
          <path
            fill="#F9E6CA"
            d="M93.405 284.474l50.659-9.129h39.816c8.681 0 16.121-7.814 17.678-18.567l28.49-196.823c.257-1.775.571-3.32.898-4.664 2.109-8.647-5.601-2.54-7.085 6.235-5.36 31.706-19.325 105.909-39.981 155.474-19.281 46.267-81.074 56.179-114.469 58.085-11.315.646-14.369 7.687-3.103 8.926 8.948.984 18.787.805 23.93.757a18.78 18.78 0 003.167-.294z"
            opacity="0.8"
          ></path>
        </g>
        <path
          fill="#344861"
          d="M220.109 17.13l-4.818-11.713C214.211 2.792 210.958 1 207.273 1h-71.175c-4.605 0-8.348 2.766-8.385 6.197l-.127 11.713c-.038 3.47 3.728 6.297 8.386 6.297h76.119c5.638 0 9.67-4.062 8.018-8.077z"
        ></path>
        <path
          fill="#344861"
          d="M55.891 17.13L60.71 5.417C61.79 2.792 65.043 1 68.728 1h71.174c4.605 0 8.348 2.766 8.386 6.197l.126 11.713c.038 3.47-3.727 6.297-8.385 6.297h-76.12c-5.638 0-9.67-4.062-8.018-8.077z"
        ></path>
        <mask
          id="mask1_2256_161599"
          style={{ maskType: "alpha" }}
          width="166"
          height="25"
          x="55"
          y="1"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#4B5767"
            d="M220.109 17.104l-4.818-11.695C214.211 2.79 210.958 1 207.273 1h-71.175c-4.605 0-8.348 2.762-8.385 6.187l-.127 11.694c-.038 3.464 3.728 6.287 8.386 6.287h76.119c5.638 0 9.67-4.055 8.018-8.064z"
          ></path>
          <path
            fill="#4B5767"
            d="M55.891 17.104L60.71 5.409C61.79 2.79 65.043 1 68.728 1h71.174c4.605 0 8.348 2.762 8.386 6.187l.126 11.694c.038 3.464-3.727 6.287-8.385 6.287h-76.12c-5.638 0-9.67-4.055-8.018-8.064z"
          ></path>
        </mask>
        <g mask="url(#mask1_2256_161599)">
          <path
            fill="#7C5A47"
            d="M-10.202 17.574c-2.853-2.98-11.098-2.678-7.086-1.827 1.81.384 5.389.61 11.84.494 50.807-.904 143.962.553 186.931-5.166 42.969-5.719 45.953-29.9 68.138-30.696 8.171-.293 14.024-3.961 17.937-6.542 2.032-1.339 16.025 4.238 16.068 6.693l.459 26.74a4.067 4.067 0 01-3.739 4.139L12.111 34.92c-3.32.29-6.633-.968-8.97-3.41l-13.343-13.937z"
            opacity="0.3"
          ></path>
        </g>
        <rect
          width="208"
          height="36.759"
          x="34"
          y="18.034"
          fill="#344861"
          rx="10.759"
        ></rect>
        <mask
          id="mask2_2256_161599"
          style={{ maskType: "alpha" }}
          width="208"
          height="37"
          x="34"
          y="18"
          maskUnits="userSpaceOnUse"
        >
          <rect
            width="208"
            height="36.642"
            x="34"
            y="18.151"
            fill="#C79E87"
            rx="10.759"
          ></rect>
        </mask>
        <g mask="url(#mask2_2256_161599)">
          <path
            fill="#7C5A47"
            d="M-2.858 54.536c-2.563-2.757-9.73-3.043-6.021-2.572 1.894.241 5.507.395 11.876.362 50.816-.27 152.272-1.509 193.396-8.35 41.124-6.84 45.843-24.314 55.021-28.943 7.074-3.569 14.834-9.522 18.789-12.053 3.78-2.419 19.15 2.199 19.885 6.68l5.13 31.253c.86 5.239-2.869 10.008-8.153 10.429L19.641 72.62c-3.338.265-6.648-1.034-8.956-3.517L-2.858 54.536z"
            opacity="0.3"
          ></path>
        </g>
        <path
          fill="#B1856D"
          d="M46.524 94.996a5.38 5.38 0 015.326-6.134h173.131a5.379 5.379 0 015.318 6.189l-18.017 118.345a5.38 5.38 0 01-5.319 4.57H68.611a5.38 5.38 0 01-5.326-4.625L46.524 94.996z"
        ></path>
        <mask
          id="mask3_2256_161599"
          style={{ maskType: "alpha" }}
          width="185"
          height="130"
          x="46"
          y="88"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#B1856D"
            d="M46.524 94.996a5.38 5.38 0 015.326-6.134h173.131a5.379 5.379 0 015.318 6.189l-18.017 118.345a5.38 5.38 0 01-5.319 4.57H68.611a5.38 5.38 0 01-5.326-4.625L46.524 94.996z"
          ></path>
        </mask>
        <g mask="url(#mask3_2256_161599)">
          <path
            fill="#B1856D"
            d="M105.905 280.199l50.659-9.13h39.816c8.681 0 22.063-7.316 23.62-18.069l31.5-191c1.407-9.718.123-15.628-4.617-18.301-4.604-2.597-10.029.647-12.795 5.15C229.593 56.169 222.754 69.428 217.5 89c-2.5 20.5-17.5 95.5-33 127.5-11.733 24.222-77.039 43.041-108.09 50.758-9.203 2.287-11.942 10.134-2.603 11.776 10.01 1.759 22.804 1.515 28.932 1.458a18.785 18.785 0 003.166-.293z"
            opacity="0.2"
          ></path>
        </g>
        <rect
          width="114.621"
          height="114.621"
          x="80.69"
          y="95.69"
          fill="#fff"
          stroke="#F9E6CA"
          strokeWidth="5.379"
          rx="57.31"
        ></rect>
        {children}
      </g>
    </svg>
  );
}
